export default [
    {
        path: '/public/chat',
        name: 'public-chat',
        component: () => import('@/views/public/Chat.vue'),
        meta: {
            contentRenderer: 'sidebar-left',
            contentClass: 'chat-application',
            layout: 'public',
            action: 'read',
            resource: 'auth',
        },
    },
];
